import React from "react";
import Slider from "./slider/slider";
import * as Icon from 'react-feather';
import "./content.scss"

const Content = (props) => (
    <div id="content">
        <Slider/>
        <div id="home" className="container">
            <div className="content-title align-content-center">
                <h2>Herzlich Willkomen und vielen Dank für Ihren Besuch</h2>
                <div className="line"></div>
                <div className="row content">
                    <div className="col-sm-12">
                        <p>
                            Wir sind ein unabhängiges mittelständisches Unternehmen. Ein bedeutender Schwerpunkt unserer
                            Tätigkeit ist der <strong>Wohnungsbau für preisbewusste Familien</strong>.

                        </p>
                        <p>
                            Sie können von uns und unseren Partnern <strong>nahezu alle Dienstleistungen</strong>, von
                            der Entwicklung bis zur Vermarktung, bei Wohn-
                            und Gewerbeimmobilien erhalten.
                        </p>
                        <p>
                            Zu Ihrem Vorteil arbeiten wir mit <strong>Handwerkern und Baufirmen aus der Region</strong>.
                            Sehen Sie uns als Dienstleister – für Sie stehen wir auch außerhalb üblicher Konventionen
                            zur Seite.
                        </p>
                        <div className="home-content-title">
                            <h3>Ihre Wünsche sind unser Auftrag.</h3>
                            <div className="line"></div>
                        </div>
                        <p>
                            Sie sind der Mittelpunkt unseres Handelns. Gemäß dem Motto „Vermögen schaffen – Werte
                            erhalten“ verwirklichen Sie mit uns Ihre persönlichen Ziele, Wünsche und Ihre WohnTräume.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="dark">
            <div id="ueber_mich" className="container">
                <div className="content-title align-content-center">
                    <h2>Über mich</h2>
                    <div className="line"></div>
                </div>
                <div className="row content">
                    <div className="col-sm-12">
                        <img className="profile" src={require("./images/frank_stiebing.jpg")} alt="Frank Stiebing"/>
                        <p className="text-center name">Frank Stiebing</p>
                        <div className="line"></div>
                    </div>
                </div>
                <div className="row content">
                    <div className="col-sm-12">
                        <p>Verheiratet, Jahrgang 1968, zwei Söhne.</p>
                        <p>Seit 2003: Stiebing Immobilien und Baumanagement GmbH, Erlangen (SIB GmbH).</p>
                        <p>Bis 2003: über 10 Jahre Bereichsleiter für Vertrieb von Immobilien und -beteiligungen bei der
                            Bankgesellschaft Berlin AG. Dort habe ich meine "Immobilienbildung" erworben, vertrieft und
                            ein wertvolles Netzwerk aufgebaut.</p>
                        <p>Für Sie und zu Ihrem Vorteil setze ich meine <strong>über 25 Jahre Erfahrungen und
                            Kenntnisse</strong> ein. Nutzen Sie diesen reichen Erfahrungsschatz!</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="light">
            <div id="projekte" className="container">
                <div className="content-title align-content-center">
                    <h2 id="ueber_mich">Aktuelle Projekte</h2>
                    <div className="line"></div>
                </div>
                <div className="row content">
                    <h3>NEUBAU-Wohnimmobilien - PROVISIONSFREI</h3>
                    <h4>Eigentumswohnungen <a href="https://goo.gl/maps/SLfb6bhRC8S3j1ju9">Erlangen-Frauenaurach,
                        Heinrichsdörferweg 4</a></h4>
                    <p className="hint">(Visualisierungen und Grundrisse sind Gestaltungsvorschläge die im Original
                        abweichen können.)</p>
                </div>
                <div className="row content">
                    <div className="col-sm-6">
                        <div className="card">
                            <img className="card-img-top"
                                 src={require("./images/projekte/heinrichsdoerferweg_ueberblick.jpg")} alt="Projekt"/>
                            <div className="card-body">
                                <h5 className="card-title">Ansicht von oben</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card">
                            <img className="card-img-top"
                                 src={require("./images/projekte/heinrichsdoerferweg_strasse.jpg")} alt="Projekt"/>
                            <div className="card-body">
                                <h5 className="card-title">Ansicht vom Heinrichsdörferweg</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card">
                            <img className="card-img-top"
                                 src={require("./images/projekte/heinrichsdoerferweg_garten.jpg")} alt="Projekt"/>
                            <div className="card-body">
                                <h5 className="card-title">Ansicht vom Garten</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card">
                            <img className="card-img-top" height="245px"
                                 src={require("./images/projekte/grundriss_terrasse.gif")} alt="Projekt"/>
                            <div className="card-body">
                                <h5 className="card-title">Beispiel Grundriss Terrasse</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card">
                            <img className="card-img-top" src={require("./images/projekte/grundriss_loggia.gif")}
                                 alt="Projekt"/>
                            <div className="card-body">
                                <h5 className="card-title">Beispiel Grundriss Loggia</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card">
                            <img className="card-img-top" src={require("./images/projekte/grundriss_balkon.gif")}
                                 alt="Projekt"/>
                            <div className="card-body">
                                <h5 className="card-title">Beispiel Grundriss Balkon</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row content">
                    <h3>Immobilien in Vermittlung bei <a
                        href="https://www.immowelt.de/profil/f0d50f7feb32c341bb050ad370b5cd53">Immowelt</a></h3>
                </div>
            </div>
        </div>
        <div className="dark">
            <div id="kontakt" className="container">
                <div className="content-title align-content-center">
                    <h2 id="ueber_mich">Kontakt</h2>
                    <div className="line"></div>
                </div>
                <div className="row content">
                    <div className="col-sm-6">
                        <h3>Stiebing Immobilien und Baumanagement GmbH</h3>
                        <h5>Frank Stiebing</h5>
                        <div className="row contact-row">
                            <Icon.MapPin size={35}/>
                            <p>
                                Fanny-Hensel-Straße 2<br/>
                                91056 Erlangen
                            </p>
                        </div>
                        <div className="row contact-row">
                            <Icon.Phone size={35}/>
                            <p><a href="tel:091316879760">09131 / 68 79 760</a></p>
                        </div>
                        <div className="row contact-row">
                            <Icon.Mail size={35}/>
                            <p><a href="mailto:frank.stiebing@sib-immobilien.de">frank.stiebing@sib-immobilien.de</a>
                            </p>
                        </div>
                    </div>
                    <div className="col-sm-6 contact__map">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2587.737960458147!2d10.965110016234142!3d49.564967258648174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a1ff4133667ae7%3A0x5d81dabb3a2af066!2sStiebing+Immobilien+und+Baumanagement+GmbH!5e0!3m2!1sde!2sde!4v1549814026352"
                            width="100%" height="100%" frameBorder="0" title="Karte Stiebing Immobilien"
                            allowFullScreen></iframe>
                    </div>

                </div>
            </div>
        </div>

    </div>
)

export default Content;



// WEBPACK FOOTER //
// ./src/content/content.js